/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the action type of a rollout.
 */
export type RolloutType = 'IRR_UPGRADE' | 'OAUTH_APP_ROTATE' | 'IRR_GW_CERT_UPDATE';

export const RolloutType = {

    IRR_UPGRADE: 'IRR_UPGRADE' as RolloutType,

    OAUTH_APP_ROTATE: 'OAUTH_APP_ROTATE' as RolloutType,

    IRR_GW_CERT_UPDATE: 'IRR_GW_CERT_UPDATE' as RolloutType
};

